/**
 * Creates a sequence of array of any size
 */
export const createSequence = (length: number, offset = 0): Array<number> =>
  length > 0
    ? Array.from(new Array(length), (...args) => args[1] + offset)
    : [];

export default createSequence;
